import React, { useState } from 'react';
import axios from 'axios';
import { API_URL } from '../../config/api';

const ApiPlayground = () => {
  const [headline, setHeadline] = useState('US Expands Chip Export Controls to China');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const analyzeHeadline = async () => {
    if (!headline.trim()) return;
    
    setLoading(true);
    try {
      const res = await axios.post(`${API_URL}/v1/playground/analyze`, {
        headline,
        region: 'us'
      });
      setResult(res.data);
    } catch (err) {
      setResult({ error: 'Analysis failed. Try again.' });
    } finally {
      setLoading(false);
    }
  };

  const sampleHeadlines = [
    "US Expands Chip Export Controls to China",
    "Tesla Opens New Gigafactory in India",
    "EU Proposes New AI Regulation Framework",
    "Oil Prices Surge Amid Middle East Tensions"
  ];

  return (
    <div className="api-playground" data-testid="api-playground">
      <div className="playground-input">
        <label>Test a headline:</label>
        <div className="input-row">
          <input
            type="text"
            value={headline}
            onChange={(e) => setHeadline(e.target.value)}
            placeholder="Enter a news headline..."
            data-testid="playground-input"
          />
          <button 
            onClick={analyzeHeadline} 
            disabled={loading}
            data-testid="playground-analyze"
          >
            {loading ? 'Analyzing...' : 'Analyze'}
          </button>
        </div>
        <div className="sample-headlines">
          <span>Try:</span>
          {sampleHeadlines.map((h, i) => (
            <button 
              key={i} 
              className="sample-btn"
              onClick={() => setHeadline(h)}
            >
              {h.substring(0, 30)}...
            </button>
          ))}
        </div>
      </div>
      
      {result && !result.error && (
        <div className="playground-result" data-testid="playground-result">
          <div className="result-header">
            <span className="fdi-label">FDI Score</span>
            <span className={`fdi-value ${result.fdi_score > 60 ? 'high' : result.fdi_score > 40 ? 'medium' : 'low'}`}>
              {result.fdi_score}
            </span>
          </div>
          <div className="result-tags">
            <span className="label">Detected Tags:</span>
            <div className="tags">
              {result.tags.map((tag, i) => (
                <span key={i} className="tag">{tag}</span>
              ))}
            </div>
          </div>
          {result.divergent_regions && result.divergent_regions[0] !== 'none_detected' && (
            <div className="result-regions">
              <span className="label">Divergent Regions:</span>
              <div className="regions">
                {result.divergent_regions.map((r, i) => (
                  <span key={i} className="region">{r}</span>
                ))}
              </div>
            </div>
          )}
          <p className="result-note">{result.analysis_note}</p>
        </div>
      )}
      
      {result?.error && (
        <div className="playground-error">{result.error}</div>
      )}
    </div>
  );
};

export default ApiPlayground;
